import {urlTransformer, urlValidator} from '@cohort/shared/utils/validators';
import {z} from 'zod';

export const UrlInputSchema = z
  .string()
  .refine(url => url === '' || urlValidator(url), 'errorUrl')
  .transform(url => (url !== '' ? urlTransformer(url) : null));
